/**
 * @generated SignedSource<<47d7fcf1f10547547ad3a73ed397c318>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SetAsDefaultItem_container$data = {
  readonly id?: string;
  readonly scopeId?: string | null | undefined;
  readonly " $fragmentType": "SetAsDefaultItem_container";
};
export type SetAsDefaultItem_container$key = {
  readonly " $data"?: SetAsDefaultItem_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"SetAsDefaultItem_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SetAsDefaultItem_container",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "scopeId"
        }
      ],
      "type": "JiraContainerNavigation"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "656aa8c184c3ae35259916ec5158b9d3";

export default node;
